<template>
  <b-card no-body class="mt-6">
    <el-table
      class="table-responsive table-flush"
      header-row-class-name="thead-light table-th-color table-textcenter"
      :data="allData.data"
      border
    >
      <!-- <b-input-group class="mt-12">
        <b-form-input
          class="border-none shadow-lg"
          type="text"
          min="0.00"
          placeholder="Enter Search...."
          v-model="search"
          @input="handleSearch"
        ></b-form-input>

        <b-input-group-append>
          <b-button
            variant="white"
            class="flex items-center shadow-lg"
            aria-label="search"
          >
            <feather-icon
              class="cursor-pointer mr-2"
              icon="SearchIcon"
              svgClasses="w-4 h-4"
            ></feather-icon>
          </b-button>
        </b-input-group-append>
      </b-input-group> -->

      <el-table-column label="Question" prop="title" width="320px">
        <template v-slot="{ row }">
          <div v-html="row.question"  class="ellipsis-2"></div>
          <!-- <p class="font-semibold text-left name mb-0 text-sm">
            {{ row.question }}
          </p> -->
        </template>
      </el-table-column>
      <el-table-column label="Answer" prop="title">
        <template v-slot="{ row }">
          <div v-html="row.answer"  class="ellipsis-3"></div>
          <!-- <p class="font-semibold text-left name mb-0 text-sm">
            {{ row.answer }}
          </p> -->
        </template>
      </el-table-column>
      <!-- <el-table-column label="Date" prop="title">
        <template v-slot="{ row }">
          <p class="font-semibold text-left name mb-0 text-sm">
            {{
              new Date(row.createdAt).toLocaleDateString(undefined, {
                year: "numeric",
                month: "long",
                day: "numeric",
              })
            }}
          </p>
        </template>
      </el-table-column> -->

      <!-- Category Column with Dropdown -->
      <el-table-column label="Category" width="150px">
        <template v-slot="{ row }">
          <p class="font-semibold text-left name mb-0 text-sm">
            {{ row.category }}
          </p>
        </template>
      </el-table-column>

      <!-- Subcategory Column with Dropdown -->
      <!-- <el-table-column label="Subcategory" width="150px">
        <template v-slot="{ row }">
          <p class="font-semibold text-left name mb-0 text-sm">
            {{ row.subcategory }}
          </p>
        </template>
      </el-table-column> -->

      <el-table-column
        label="Status"
        min-width="120px"
        class-name="text-center"
      >
        <template v-slot="{ row }">
          <el-switch
            v-model="row.active"
            active-color="#13ce66"
            inactive-color="#ff4949"
            @change="(e) => handleStatusToggle(e, row)"
          ></el-switch>
        </template>
      </el-table-column>

      <el-table-column
        label="Actions"
        min-width="40px"
        class-name="text-center"
      >
        <template slot-scope="scope">
          <div class="flex justify-center items-center">
            <feather-icon
              icon="EditIcon"
              svgClasses="w-6 text-blue-500 cursor-pointer"
              class="mr-2"
              @click="handleEdit(scope)"
            ></feather-icon>
            <feather-icon
              icon="Trash2Icon"
              svgClasses="w-6 text-red-600 cursor-pointer"
              class="ml-2"
              @click="handleDelete(scope)"
            ></feather-icon>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <b-card-footer class="py-4 d-flex justify-content-end">
      <base-pagination
        v-model="currentPage"
        :per-page="perPage"
        :total="allData.count"
        @change="handlePageChange"
      ></base-pagination>
    </b-card-footer>
  </b-card>
</template>

<script>
// import Data from "./Data";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Button,
} from "element-ui";

import { mapState } from "vuex";

export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Button.name]: Button,
  },
  data() {
    return {
      currentPage: 1,
      perPage: 10,
      allData: [],
      //  categories: ["Palliative", "Cancer"],

      // // Subcategories for each category
      // subcategories: {
      //   Palliative: [
      //     "About Palliative Care",
      //     "History",
      //     "Principals & Framework",
      //     "Issues & Importance",
      //   ],
      //   Cancer: [
      //     "About Us",
      //     "Treatment Options",
      //     "Side Effects",
      //     "Emotional Support",
      //     "Nutrition",
      //     "Financial Support",
      //     "History",
      //     "Principals & Framework",
      //     "Issues & Importance",
      //   ],
      // },
    };
  },

  methods: {
    // async handleSearch() {
    //   this.currentPage = 1;
    //   this.function();
    // },

    async handleStatusToggle(e, data) {
      console.log(e, data);
      let pay = {
        id: data._id,
        active: e,
      };
      try {
        const newsdata = await this.$store.dispatch(
          "medicalFaq/updateMedicalFaq",
          pay
        );
        await this.function();
      } catch (err) {
        await this.function();
      }

      // console.log("123", newsdata);
    },
    async function(e) {
      let loader = this.$loading();
      let payload = {
        limit: this.perPage,
        offset: this.perPage * this.currentPage - this.perPage,
        pagination: true,
        // active: true,
        // search: this.search,
      };

      try {
        await this.$store.dispatch("medicalFaq/getMedicalFaq", payload);

        this.allData = this.AllMedicalFaq;
      } catch (error) {
        console.log(error);
      }
      loader.close();
    },

    async handleEdit(scope) {
      let { row } = scope;
      await this.$store.commit(
        "medicalFaq/SET_SELECTED_MEDICAL_FAQ_FOR_UPDATE",
        row
      );
      this.$router.push({ name: "editFaq" });
    },
    async handleDelete(data) {
      const result = await this.deleteAlert();
      if (result.isConfirmed) {
        this.deleteData(data);
        this.$swal.fire({
          text: "Data Successfully Deleted",
          icon: "success",
          confirmButtonText: "Okay",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
      }
    },
    deleteAlert() {
      return this.$swal({
        title: "Are you sure?",
        html: `<p class="text-center">You won't be able to revert this!</p>`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#830c81",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      });
    },
    async deleteData({ row }) {
      const payload = { id: row._id };
      let loader = this.$loading();
      try {
        await this.$store.dispatch("medicalFaq/deleteMedicalFaq", payload);
        this.function();
        loader.close();
      } catch (error) {
        loader.close();
      }
    },
    handlePageChange(value) {
      this.currentPage = value;
      this.function();
    },
  },
  computed: {
    ...mapState("medicalFaq", ["AllMedicalFaq"]),
  },
  async mounted() {
    await this.function();
    console.log("1234", this.AllMedicalFaq);
  },
};
</script>

<style scoped>
.clr606266 {
  color: #606266;
}
</style>
